import { Request } from '../../../httpClient/serverApi/requests/Request';
import { IGetItemsParams } from '../../../ts/ServerApi/types/IGetItemsParams';
import { IGetItemsResult } from '../../../ts/ServerApi/types/IGetItemsResult';
import { IUser } from '../../../ts/ServerApi/types/IUser';
import { INamedItem } from '../../../ts/ServerApi/types/resourceParts';
import { IPublishedConnection } from '../types/IPublishedConnection';

export interface IGetPublishedConnectionsParams extends IGetItemsParams {
}

export interface IGetPublishedConnectionsResult extends IGetItemsResult {
  publishedConnections?: IPublishedConnection[];
  users?: IUser[];
  projects?: INamedItem[];
  favorites?: string[];
}

export class GetPublishedConnectionsRequest extends Request<IGetPublishedConnectionsParams, IGetPublishedConnectionsResult> {
  constructor(params: IGetPublishedConnectionsParams) {
    super('getPublishedConnections', params);
  }
}
